import { colors, makeStyles } from '@material-ui/core'

const styles = (props) =>
  makeStyles((theme) => ({
    boxFather: {
      backgroundColor: colors.grey[100],
      boxShadow: theme.shadows[1],
      gridGap: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(3),
      borderRadius: 1,
    },
    boxPortal: {
      borderTopRightRadius: 5,
      borderTopLeftRadius: 5,
      backgroundColor: props.primaryColor,
      boxShadow: theme.shadows[1],
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingBottom: '20px',
    },
    typographyHeader: {
      borderTopLeftRadius: 5,
      textTransform: 'uppercase',
      color: props.primaryTextColor,
      padding: theme.spacing(2),
    },
    BoxPrivacyFriendlyOrganization: {
      backgroundColor: props.secondaryColor,
      borderTopLeftRadius: 5,
      borderTopRightRadius: 5,
      padding: theme.spacing(2),
    },
    typographyPrivacyFriendlyOrganization: {
      textAlign: 'center',
      color: props.secondaryTextColor,
    },
    boxCompanyData: {
      backgroundColor: 'white',
      borderBottomLeftRadius: 5,
      borderBottomRightRadius: 5,
      boxShadow: theme.shadows[1],
      display: 'flex',
      gap: 10,
    },
    avatarCompany: {
      borderRadius: 4,
      backgroundColor: props.secondaryColor,
    },
    boxFatherButtonPreview: {
      backgroundColor: colors.common.white,
      boxShadow: theme.shadows[1],
      display: 'flex',
      justifyContent: 'center',
      gap: 40,
      padding: 40,
    },
    boxButtonPreviewOne: {
      minHeight: 180,
      padding: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'end',
      boxShadow: theme.shadows[1],
      borderRadius: 1,
    },
    boxButtonPreviewTwo: {
      boxShadow: theme.shadows[1],
      backgroundColor: props.secondaryColor,
      cursor: 'pointer',
      padding: theme.spacing(1),
      borderRadius: 4,
      width: '100%',
    },
    typographyButtonPreview: {
      color: props.secondaryTextColor,
      textAlign: 'center',
      textTransform: 'uppercase',
      fontWeight: 500,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      msWordBreak: 'break-all',
    },
    boxFooter: {
      borderBottomLeftRadius: 5,
      borderBottomRightRadius: 5,
      backgroundColor: props.primaryColor,
      boxShadow: theme.shadows[1],
      padding: theme.spacing(2),
    },
    typographyFooter: {
      color: props.primaryTextColor,
      textAlign: 'center',
      textTransform: 'uppercase',
    },
    linkPortal: {
      color: colors.common.black,
    },
    typographyViewChannel: {
      textAlign: 'center',
    },
    gridCompanyDataResponsibleDpo: {
      color: colors.common.black,
    },
    companyData: {
      fontWeight: 700,
    },
  }))

export default styles
